import React, { useContext } from "react";
import BetSlipContext from "../context/BetSlipContext";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
const BackLayFav = ({
  component,
  handelChange,
  odds_lay,
  odds_back,
  index,
  item,
  limit,
  marketName,
  type,
  disabelBack,
  disabelLay,
  object,
  res,
  conditionNew,
}) => {
  const { betSlipObject, showBetDialog, setLimit } = useContext(BetSlipContext);
  let backClass = `back ${
    Number(
      document
        .getElementById(
          "back_odds_" + item?.SelectionId ||
            item?.selectionID + index + res?.marketId ||
            res?.bookmakerMarketId
        )
        ?.title?.split("-")[0]
        ?.trim()
    ) != odds_back[0]?.rt ||
    Number(
      document
        .getElementById(
          "back_odds_" + item?.SelectionId ||
            item?.selectionID + index + res?.marketId ||
            res?.bookmakerMarketId
        )
        ?.title?.split("-")[1]
        ?.trim()
    ) != odds_back[0]?.bv
      ? "spark-back working"
      : ""
  } ${
    betSlipObject?.teamName == item?.RunnerName|| item?.runnerName &&
    betSlipObject?.odds == odds_back[0]?.rt &&
    showBetDialog
      ? "back-active"
      : ""
  }`;
  let layClass = `lay ${
    Number(
      document
        .getElementById(
          "lay_odds_" + item?.SelectionId ||
            item?.selectionID + index + res?.marketId ||
            res?.bookmakerMarketId
        )
        ?.title?.split("-")[0]
        ?.trim()
    ) != odds_lay[0]?.rt ||
    Number(
      document
        .getElementById(
          "lay_odds_" + item?.SelectionId ||
            item?.selectionID + index + res?.marketId ||
            res?.bookmakerMarketId
        )
        ?.title?.split("-")[1]
        ?.trim()
    ) != odds_lay[0]?.bv
      ? "spark-lay"
      : ""
  } ${
    betSlipObject?.teamName == item?.RunnerName || item?.runnerName &&
    betSlipObject?.odds == odds_lay[0]?.rt &&
    showBetDialog
      ? "lay-active"
      : ""
  }`;

  let checkDisabled = (odds) => {
    if (Number(odds) > 0) {
      if (Number(odds) > limit?.oddsLimit) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  let check = (odds) => {
    if (!conditionNew) {
      if (Number(odds) > 0) {
        if (Number(odds) > limit?.oddsLimit) {
          return "single-disabled";
        } else {
          return "";
        }
      } else {
        return "single-disabled";
      }
    }
  };
  let backCheck = check(odds_back[0]?.rt, component, disabelBack) || "";
  let layCheck = check(odds_lay[0]?.rt, component, disabelLay) || "";
  const navigate = useNavigate();
  return (
    <div
      className={`lay-back-table ${
        component == "bookmaker" ? "bg-bookmaker-market" : ""
      }`}
    >
      <div
        title={`${odds_back[0]?.rt}-${odds_back[0]?.bv}`}
        id={
          "back_odds_" + item?.SelectionId ||
          item?.selectionID + index + res?.marketId ||
          res?.bookmakerMarketId
        }
        onClick={() => {
          if (component == "betfair" && disabelBack) {
          } else {
            if (!checkDisabled(odds_back[0]?.rt)) {
              handelChange(
                odds_back[0],
                "back",
                item?.RunnerName || item?.runnerName,
                res || object,
                index,item
              );
              setLimit(limit);
            }
          }
        }}
        className={backClass}
      >
        <span className={backCheck}>
          {backCheck == "single-disabled" && <span className="disabled"></span>}
          <span style={{ fontWeight: "700" }}>{odds_back[0]?.rt || ""}</span>
          {component == "bookmaker" ? (
            ""
          ) : (
            <span className="d-block">{odds_back[0]?.bv || ""}</span>
          )}
        </span>
      </div>
      <div
        title={`${odds_lay[0]?.rt}-${odds_lay[0]?.bv}`}
        id={
          "lay_odds_" + item?.SelectionId ||
          item?.selectionID + index + res?.marketId ||
          res?.bookmakerMarketId
        }
        onClick={() => {
          if (component == "betfair" && marketName == "To Win the Toss") {
          } else {
            if (component == "betfair" && disabelLay) {
            } else {
              if (!checkDisabled(odds_lay[0]?.rt)) {
                handelChange(
                  odds_lay[0],
                  "lay",
                  item?.RunnerName || item?.runnerName,
                  res || object,
                  index,item
                );
                setLimit(limit);
              }
            }
          }
        }}
        className={layClass}
      >
        <span className={layCheck}>
          {layCheck == "single-disabled" && <span className="disabled"></span>}
          <span style={{ fontWeight: "700" }}>{odds_lay[0]?.rt || ""}</span>
          {component == "bookmaker" ? (
            ""
          ) : (
            <span className="d-block">{odds_lay[0]?.bv || ""}</span>
          )}
        </span>
      </div>
    </div>
  );
};

export default BackLayFav;
